import groups from '@/constants/queryKeys/groups'
import tags from '@/constants/queryKeys/tags'
import users from '@/constants/queryKeys/users'
import roles from '@/constants/queryKeys/roles'
import personsById from '@/constants/queryKeys/personsById'
import userFields from '@/constants/queryKeys/userFields'
import preferences from '@/constants/queryKeys/preferences'
import exportExcelConfig from '@/constants/queryKeys/exportExcelConfig'
import taggedPeople from '@/constants/queryKeys/taggedPeople'
import calendars from '@/constants/queryKeys/calendars'
import forms from '@/constants/queryKeys/forms'
import familyPictures from '@/constants/queryKeys/familyPictures'
import profileMerge from '@/constants/queryKeys/profileMerge'
import followups from '@/constants/queryKeys/followups'
import families from '@/constants/queryKeys/families'

export default {
    preferences,
    followups,
    tags,
    userFields,
    users,
    roles,
    groups,
    exportExcelConfig,
    taggedPeople,
    personsById,
    calendars,
    forms,
    families,
    familyPictures,
    profileMerge
}
